import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Changes } from '../changes';
import { LdwRouterService } from '../../route/ldw-router.service';
import { WebdokuService } from '../../web-doku/webdoku.service';
import { InfoService } from '../../shared/services/info.service';
import { ActivatedRoute } from '@angular/router';
import { switchMap, take, tap } from 'rxjs/operators';
import { Observable, of, Subscription } from 'rxjs';

@Component({
    selector: 'ldw-info-changed',
    templateUrl: './info-changed.component.html',
    styleUrls: ['./info-changed.component.css'],
    standalone: false
})
export class InfoChangedComponent implements OnInit, OnDestroy {
  private routerService = inject(LdwRouterService);
  private infoService = inject(InfoService);
  private route = inject(ActivatedRoute);
  private webDokuService = inject(WebdokuService);

  changes: Changes[] | [] = [];
  displayedColumns: string[] = [
    'text',
    'isNew',
    'status',
    'docStatus',
    'info',
    'computer',
    'changed',
    'changedBy',
    'project',
    'path',
  ];

  protected wdSubscription!: Subscription;

  constructor() {
    this.infoService.clearStatus();
  }
  ngOnInit(): void {
    this.wdSubscription = this.route.paramMap.subscribe((params) => {
      const wd = params.get('wd') ?? '';
      this.webDokuService
        .selectWebDoku(wd)
        .pipe(
          switchMap((selectWdOk) => this.getChanges(selectWdOk)),
          take(1)
        )
        .subscribe();
    });
  }

  ngOnDestroy() {
    this.wdSubscription.unsubscribe();
  }

  getChanges(selectWdOk: boolean): Observable<Changes[]> {
    if (selectWdOk) {
      return this.webDokuService.getChanges().pipe(
        tap((res) => {
          this.changes = res;
          this.infoService.setLoadedItems(this.changes.length);
        })
      );
    } else {
      this.changes = [];
      this.infoService.setStatus(`can't activate`);
      return of(this.changes);
    }
  }

  getRoute(row: Changes) {
    if (row == undefined || row.documentId == undefined) {
      return;
    }
    return this.routerService.getDocumentEditorRoute(row.documentId);
  }
}
